export const GST_RATE = 0.18;

// round to nearest whole number
const round0 = (value) => Math.round(value);

export function calculateItem(item) {
  const amount = round0(item.rate * item.quantity);
  const discount = round0(item.discount || 0);

  const taxableAmount = round0(amount - discount);
  const igst = round0(taxableAmount * GST_RATE);

  return {
    amount,
    discount,
    taxableAmount,
    igst,
    total: round0(taxableAmount + igst),
  };
}

export function calculateTotals(items) {
  return items.reduce(
    (acc, item) => {
      acc.amount = round0(acc.amount + item.amount);
      acc.discount = round0(acc.discount + item.discount);
      acc.taxableAmount = round0(acc.taxableAmount + item.taxableAmount);
      acc.igst = round0(acc.igst + item.igst);
      acc.total = round0(acc.total + item.total);
      return acc;
    },
    {
      amount: 0,
      discount: 0,
      taxableAmount: 0,
      igst: 0,
      total: 0,
    }
  );
}
